<template>
    <!-- 展示二维码的弹框 -->
    <el-dialog
      :visible.sync="qrcodeDialogVisible"
      width="25%"
      destroy-on-close
      @close="qrcodeDialogClosed"
      :title="title?title:text">
      <div class="container">
        <img id='qrcode' v-bind:src="src"/>
      </div>
    </el-dialog>
</template>

<script>
import AraleQRCode from 'arale-qrcode'
export default {
    props: {
      text: {
       default: ''
      },
      title: {
        default: undefined
      }
    },
    data() {
        return {
            qrcodeDialogVisible: false,
            currentText: ''
        }
    },
    methods: {
        // 外部调用展示二维码
        show() {
            this.$nextTick(() => {
                this.qrcodeDialogVisible = true
                this.bulid()
            })
        },
        // 生成二维码
        bulid() {
            const result = new AraleQRCode({
                render: 'svg', /*  生成的类型 'svg' or 'table dom元素类型 */
                text: this.currentText, /* 二维码的链接 */
                size: 200 /* 二维码的大小 */
            })
            const svgXml = new XMLSerializer().serializeToString(result)
            this.src = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(svgXml)))
        }
    },
    watch: {
        text(value) {
            this.currentText = value
        }
    }
}
</script>

<style>
.container{
    vertical-align: middle;
    text-align: center;
}
.qrcode{
    position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;
}
</style>
